import axios from 'axios';
import Api from './Api';

const { CancelToken } = axios;
let cancelRead;
class WipPanelScheduleApi extends Api {
  constructor() {
    super('wip-panel-schedules', 'wip-panel-schedules');
  }

  async readData(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    });
    return res;
  }

  async readWindowBreakdown(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    }, 'read-window-breakdown');
    return res;
  }
}
const wipPanelScheduleApi = new WipPanelScheduleApi();

export default wipPanelScheduleApi;
